import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Day } from '~/api/shipping/carrier.types'

export function useGetWeekday() {
  const i18n = useI18n()

  const weekdayMapping: Record<Day, string> = {
    MONDAY: i18n.date(new Date('2001-01-01'), { weekday: 'long' }),
    TUESDAY: i18n.date(new Date('2001-01-02'), { weekday: 'long' }),
    WEDNESDAY: i18n.date(new Date('2001-01-03'), { weekday: 'long' }),
    THURSDAY: i18n.date(new Date('2001-01-04'), { weekday: 'long' }),
    FRIDAY: i18n.date(new Date('2001-01-05'), { weekday: 'long' }),
    SATURDAY: i18n.date(new Date('2001-01-06'), { weekday: 'long' }),
    SUNDAY: i18n.date(new Date('2001-01-07'), { weekday: 'long' }),
  }

  return (day: Day) => weekdayMapping[day]
}
